export const envIsProduction = process.env.NODE_ENV === "production";
export const envIsLocal =
    process.env.NODE_ENV === "local" || process.env.NODE_ENV === "development";
